/*
 * 警告信
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import { WarningLetterReq, DownWarningLetterReq, WarningLetterListReq  } from "@/pbjs/xcommon/ticket_pb";
import { Page } from "@/utils/index";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import InnerRequest from "./request";

export function getWarningLetterListReq(arg: any) {
    let request: any = new WarningLetterListReq();
    request.setCaseid(arg.Caseid);
    return request ;
}

export const getWarningLetterListReqRequest = new InnerRequest(
    ticketClient,
    ticketClient.getWarningLetterList
);

export function getDownWarningLetterReq(arg: any) {
    let request: any = new DownWarningLetterReq();
    request.setId(arg.Id);
    request.setCaseid(arg.Caseid);
    request.setAccountid(arg.Accountid);
    // let _arr: any[] = [];
    // arg.penaltyFormFillinList.forEach((item: any) => {
    //     let requestAuto: any = new ApplyReducePenaltyFieldDetail();
    //     requestAuto.setFieldname(item.fieldname);
    //     requestAuto.setValue(Number(item.fieldvalue));
    //     requestAuto.setDisplayname(item.displayname);
    //     _arr.push(requestAuto);
    // });
    // request.setReductionfieldsList(_arr)
    return request ;
}

export const getDownWarningLetterRequest = new InnerRequest(
    ticketClient,
    ticketClient.downloadWarningLetter
);

export function getWarningLetterReq(arg: any) {
    let request: any = new WarningLetterReq();
    request.setCaseid(arg.Caseid);
    // let _arr: any[] = [];
    // arg.penaltyFormFillinList.forEach((item: any) => {
    //     let requestAuto: any = new ApplyReducePenaltyFieldDetail();
    //     requestAuto.setFieldname(item.fieldname);
    //     requestAuto.setValue(Number(item.fieldvalue));
    //     requestAuto.setDisplayname(item.displayname);
    //     _arr.push(requestAuto);
    // });
    // request.setReductionfieldsList(_arr)
    return request ;
}

export const sendWarningLetterRequest = new InnerRequest(
    ticketClient,
    ticketClient.sendWarningLetter
);
